module.exports = __webpack_public_path__ + "img/product-atomizer-sopuria-EVODBAR.94f1c352.jpg";